import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { IntlProvider } from 'react-intl';

import TRANSLATIONS, { getNavigatorLanguage } from '../utils/locale';
import Heading from './reusable/Heading';
import Footer from './Footer';
import Topbar from './Topbar';
import Container from './reusable/Container';
import AppContextProvider from './AppContext';

interface PageLayoutProps {
  image?: IGatsbyImageData | null;
  title?: string;
  subtitle?: string;
  beforeFooter?: React.ReactNode;
}

export const PageLayout: React.FC<React.PropsWithChildren<PageLayoutProps>> = ({
  children,
  image,
  title,
  subtitle,
  beforeFooter,
}) => {
  const language = getNavigatorLanguage();

  return (
    <IntlProvider locale={language} messages={TRANSLATIONS[language]}>
      <AppContextProvider>
        <main>
          <div className="bg-page dark:bg-zinc-900 flex flex-col items-center justify-center py-4 sm:py-0">
            <Container.FlexCols className="items-center bg-white dark:bg-brand text-brand dark:text-white rounded shadow-xl dark:shadow-none justify-center w-fit sm:w-full sm:rounded-none">
              <Container.Container className="m-4 max-w-screen-md w-auto sm:max-w-full p-2">
                <Topbar />
                {image && (
                  <div>
                    <GatsbyImage
                      image={image}
                      alt=""
                      className="m-8 rounded inset-0"
                    />
                    {title && (
                      <div>
                        <Heading.H1 className="text-left sm:text-center">
                          {title}
                        </Heading.H1>
                      </div>
                    )}
                    {subtitle && (
                      <div>
                        <Heading.H2 className="p-4 sm:text-md">
                          {subtitle}
                        </Heading.H2>
                      </div>
                    )}
                    <div />
                  </div>
                )}
                <div className="mx-auto mb-12">{children}</div>
              </Container.Container>
            </Container.FlexCols>
            <div className="max-w-screen-md w-auto sm:max-w-full py-4">
              {beforeFooter}
            </div>
          </div>
        </main>
        <Footer />
      </AppContextProvider>
    </IntlProvider>
  );
};
